import React, { useState } from 'react';
import { clsx } from '@components/Provider';
import {
  Grid,
  InputLabel,
  Select,
  MenuItem,
  TextField
} from '@material-ui/core';
import { useStyles } from './styles';
import { Controller, useFormContext } from 'react-hook-form';
import { CapaInflowRoute } from '@generated/graphql';

type InflowRoute = {
  label: string;
  value: CapaInflowRoute;
};

const inflowRoutes: InflowRoute[] = [
  { label: 'SNS 광고(인스타, 페이스북 등)', value: CapaInflowRoute.Sns },
  { label: '인터넷 검색', value: CapaInflowRoute.Internet },
  {
    label: '크리에이터블 홈페이지 및 블로그',
    value: CapaInflowRoute.Creatable
  },
  { label: '지인 및 기관 추천', value: CapaInflowRoute.Recommendation },
  { label: '홍보 기사', value: CapaInflowRoute.Article },
  { label: '이메일 광고', value: CapaInflowRoute.Email },
  { label: '전화 광고', value: CapaInflowRoute.Phone },
  { label: '문자 광고', value: CapaInflowRoute.Sms },
  { label: '카페 등 커뮤니티', value: CapaInflowRoute.Community },
  { label: '오프라인 영업', value: CapaInflowRoute.Offline },
  { label: '지면 광고 (우편, 브로셔 등)', value: CapaInflowRoute.Paper },
  { label: '서비스설명회 (온라인포함)', value: CapaInflowRoute.Presentation },
  { label: '홍보 현수막', value: CapaInflowRoute.Etc }
];

const InflowRouteSelector = () => {
  const { inflow_route, selectRoot, selectMenu, rootMenuItem } = useStyles();
  const { control, errors } = useFormContext();
  const [
    selectedFlowValue,
    setSelectedFlowValue
  ] = useState<CapaInflowRoute | null>(null);

  return (
    <Grid>
      <Grid className={inflow_route}>
        <Grid
          container
          direction="row"
          alignItems="center"
          className="inflowRouteLabel"
        >
          <InputLabel>CAPA 서비스를 어떻게 알게 되셨나요?</InputLabel>
        </Grid>
        <Controller
          control={control}
          defaultValue={''}
          name="inflowRoute"
          rules={{ required: true }}
          render={(renderProps) => (
            <Select
              {...renderProps}
              error={errors['inflowRoute']}
              classes={{
                root: clsx(selectRoot, renderProps.value ? '' : 'placeholder')
              }}
              MenuProps={{
                className: selectMenu
              }}
              variant="outlined"
              margin="dense"
              displayEmpty
              fullWidth
              onChange={(e) => {
                const selectedFlowRoute = e.target.value as CapaInflowRoute;
                setSelectedFlowValue(selectedFlowRoute);
                renderProps.onChange(selectedFlowRoute);
              }}
            >
              <MenuItem
                value=""
                disabled
                classes={{
                  root: rootMenuItem
                }}
              >
                서비스 유입경로
              </MenuItem>
              {inflowRoutes.map((option, index) => {
                return (
                  <MenuItem
                    key={index}
                    classes={{
                      root: rootMenuItem
                    }}
                    value={option.value}
                  >
                    {option.label}
                  </MenuItem>
                );
              })}
            </Select>
          )}
        />
        {selectedFlowValue === CapaInflowRoute.Recommendation && (
          <div className="recommendation-input">
            <Controller
              control={control}
              name="referralCompany"
              defaultValue=""
              rules={{
                required: {
                  value: true,
                  message: '추천 회사명 또는 기관명을 적어주세요.'
                }
              }}
              render={(renderProps) => (
                <TextField
                  variant="outlined"
                  placeholder="추천 회사명 또는 기관명을 적어주세요."
                  fullWidth
                  error={errors.referralCompany ? true : false}
                  helperText={
                    errors.referralCompany && errors.referralCompany.message
                  }
                  {...renderProps}
                />
              )}
            />
          </div>
        )}
      </Grid>
    </Grid>
  );
};

export default InflowRouteSelector;
